import React, { FC, useEffect, useState } from 'react'
import { Divider, message, Image, Empty } from 'antd'
import { maintenanceService } from '../MaintenanceService';
import useGlobalModel from '@/model/globalModel'
import { getCiImgLookUrl } from "@/utils/constants"

interface PropsType {
    showOrderId?: string;
    repairMode?: string;
}
export const ImgBox = (props: PropsType) => {
    const { showOrderId, repairMode } = props;
    useEffect(() => {
        showOrderId && init(showOrderId)
    }, [showOrderId])

    const [imageClassifyList, setImageClassifyList] = useState([])

    const init = async (id: string) => {
        try {
            let data = {
                pageSize: 100,
                pageNum: 1,
                searchItem: {
                    orderId: showOrderId,
                    imageGroup: repairMode,
                },
                orders: [],
            }
            let dataClass = {
                searchItem: {
                    imageGroup: repairMode,
                },
                pageNum: 1,
                pageSize: 100,
                orders: [
                    {
                        column: 'updateTime',
                        rule: 'DESC',
                    },
                ],
            }
            let { retData: imgList } = await maintenanceService.ciOrderImg(data)
            let { retData: imageClassifyList } = await maintenanceService.ciImageClassifyList(dataClass)
            let imageClassify = imageClassifyList.list.sort(function (a: any, b: any) {
                return b.required - a.required
            })
            let allImg = imageClassify.map((item: any) => {
                let images = imgList.list.filter((i: any) => i.attachmentType === item.imageCode)
                return { ...item, imgs: images }
            })
            setImageClassifyList(allImg)
            console.log(allImg)
        } catch {
            message.error('图片求失败')
        }
    }

    return (
        <>
            {imageClassifyList.map((item: any) => {
                return (
                    <div key={item.id}>
                        <div>
                            <div>{item.imageName}</div>

                            {
                                (item.imgs && item.imgs.length > 0) ? item.imgs.map((img: any) => (
                                    <Image style={{ margin: "10px", padding: "10px" }} key={img.attachmentMd5} width={200} src={getCiImgLookUrl(img.attachmentMd5)} />
                                )) : <Empty />
                            }

                        </div>
                        <Divider />
                    </div>
                )
            })}
        </>
    )
}
